import React from 'react';
import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';

import { DialogContext, LocalizationContext, PermissionContext } from '@cvt/contexts';
import { useRouter } from '@cvt/routing';

import { UsersHeader } from './partials/UsersHeader';
import { UsersList } from './UsersList';


export const Users = () => {
  const router = useRouter();

  const { dictionary } = React.useContext(LocalizationContext);
  const { openDialog } = React.useContext(DialogContext);
  const { permissions } = React.useContext(PermissionContext);

  return (
    <Grid container spacing={2}>
      <Grid size={12} display="flex" flexDirection="row" justifyContent="space-between">
        <Typography variant="h1">{dictionary.users.team.title}</Typography>
        <Stack spacing={1} direction="row">
          {permissions.users.create && (
            <Button
              size="medium"
              variant="contained"
              color="secondary"
              onClick={() => router.users.create.go()}
              startIcon={<Add/>}
            >
              {dictionary.users.create.buttonCreate}
            </Button>
          )}
          {permissions.users.invite && (
            <Button
              size="medium"
              variant="contained"
              color="primary"
              onClick={() => openDialog('inviteTeamMember')}
              startIcon={<Add/>}
            >
              {dictionary.users.team.buttonInvite}
            </Button>
          )}
        </Stack>
      </Grid>
      <Grid size={12}>
        <UsersHeader>
          {({ filters }) => (
            <Box mt={2}>
              <UsersList filters={filters}/>
            </Box>
          )}
        </UsersHeader>
      </Grid>
    </Grid>
  );
};
